export enum ContractStatus {
  NOT_STARTED = 'NOT_STARTED', // contract start date after current date or not set at all
  ACTIVE = 'ACTIVE', // contract start date before current date and end date after current date or not set
  ENDING = 'ENDING', // contract end date is within seven days after current date
  ENDED = 'ENDED', // contract end date less than 3 months after current date
  EXPIRED = 'EXPIRED', // contract end date is 3 months or more after current date
}
